import React from "react";

import pdf from "@react-pdf/renderer";
import { format } from "date-fns";

import { graphql } from "@/gql";
import { PdfMealPlanSubheaderFragment } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";
import { parseDateTime } from "@/utils/datetime";
import { FragmentType } from "@/utils/type";
import Logo from "@assets/images/nutricoach-logo.png";

import Flex from "./layout/Flex";

const { Text, View, StyleSheet, Image } = pdf;

const styles = StyleSheet.create({
  root: {
    width: "100%",
  },
  mainHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#DBFFF8",
    padding: "6px 15px 6px 8px",
  },
  subHeader: {
    padding: "15px 25px 0px 25px",
  },
  shLeftCol: {
    maxWidth: "350px",
  },
  title: {
    fontSize: "20px",
  },
  description: {
    fontWeight: 600,
  },
  recommendedCalories: {
    fontWeight: "extrabold",
    fontSize: "24px",
  },
  weightWatchersDiet: {
    fontWeight: "bold",
    fontSize: "14px",
    maxWidth: "350px",
  },
  textSecondary: {
    color: colors.grey,
  },
  bold: {
    fontWeight: "bold",
  },
  caption: {
    fontSize: "10px",
  },
});

type Props = {
  title: string;
  data?: FragmentType<typeof subheaderFragment>;
};

const subheaderFragment = graphql(`
  fragment PDFMealPlanSubheader on Program {
    id
    createdAt
    description
    client {
      profile {
        fullName
      }
    }
    coach {
      id
      profile {
        id
        fullName
      }
    }
    mealPlan {
      id
      recommendedCalories
    }
  }
`);

const Subheader: React.FC<Props> = ({ title, data }) => {
  return (
    <View style={styles.root}>
      <View style={styles.mainHeader}>
        <View>
          <Flex alignItems="center">
            <Image src={Logo} style={{ width: "120px", height: "40px" }} />
          </Flex>
        </View>
        <View>
          {data?.mealPlan?.recommendedCalories && (
            <Flex justifyContent="end" flexDirection="row">
              <Text style={styles.recommendedCalories}>
                {`${Math.round(data.mealPlan.recommendedCalories)} kcal`}
              </Text>
            </Flex>
          )}
          <Flex justifyContent="end" flexDirection="row">
            <Text style={styles.weightWatchersDiet}>{title}</Text>
          </Flex>
        </View>
      </View>
      {data != null && (
        <View style={styles.subHeader}>
          <Flex justifyContent="spaceBetween" flexDirection="row">
            <View style={styles.shLeftCol}>
              <Text style={[styles.bold, styles.title]}>{title}</Text>
              <Text style={[styles.caption, styles.description]}>
                {data.description}
              </Text>
            </View>
            <View>
              <Flex justifyContent="end" flexDirection="row">
                <Text
                  style={[styles.bold, styles.textSecondary, styles.caption]}
                >
                  Created For:
                </Text>
                <View style={{ marginLeft: "8px" }} />
                <Text style={[styles.bold, styles.caption]}>
                  {data?.client.profile?.fullName}
                </Text>
              </Flex>
              <Flex justifyContent="end" flexDirection="row">
                <Text
                  style={[styles.bold, styles.textSecondary, styles.caption]}
                >
                  Created By:
                </Text>
                <View style={{ marginLeft: "8px" }} />
                <Text style={[styles.bold, styles.caption]}>
                  {data?.coach.profile?.fullName}
                </Text>
              </Flex>
              <Flex justifyContent="end" flexDirection="row">
                <Text
                  style={[styles.bold, styles.textSecondary, styles.caption]}
                >
                  Created:
                </Text>
                <View style={{ marginLeft: "8px" }} />
                <Text style={[styles.bold, styles.caption]}>
                  {format(parseDateTime(data.createdAt), "yyyy-MM-dd")}
                </Text>
              </Flex>
            </View>
          </Flex>
        </View>
      )}
    </View>
  );
};
export default Subheader;
